import { useAuth } from "@/context/AuthContext";
import { fmtMoney } from "@/lib/themes";

const ROLE_EMOJI = { mom: "👩", dad: "👨", kid: "🧒" };

export function Navbar({ walletBalance }) {
  const { family, members, activeMember, selectMember, logout } = useAuth();

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-lg border-b-2 border-slate-900/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex items-center gap-3 flex-wrap">
        <div className="flex items-center gap-2 mr-auto">
          <span className="text-2xl">🎡</span>
          <div className="leading-tight">
            <div className="font-extrabold text-lg" style={{ fontFamily: "Outfit" }}>
              {family?.family_name || "Family"}
            </div>
            <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">
              Chore Wheel
            </div>
          </div>
        </div>

        {activeMember && (
          <div
            data-testid="wallet-badge"
            className="hidden sm:flex items-center gap-1 bg-[#FEF9C3] border-2 border-slate-900/10 rounded-full px-3 py-1.5 font-bold text-sm"
          >
            💰 {fmtMoney(activeMember.balance)}
            <span className="mx-1 text-slate-300">·</span>
            🍫 {activeMember.brownie_points}
          </div>
        )}

        {/* member switcher */}
        <div className="flex items-center gap-1.5 bg-slate-100 rounded-full p-1">
          {members.map((m) => (
            <button
              key={m.id}
              data-testid={`switch-member-${m.name.toLowerCase()}`}
              onClick={() => selectMember(m.id)}
              title={m.name}
              className={`flex items-center gap-1.5 rounded-full pl-1 pr-3 py-1 text-sm font-bold transition-all ${
                activeMember?.id === m.id ? "text-white shadow" : "text-slate-600 hover:bg-white"
              }`}
              style={activeMember?.id === m.id ? { background: m.color } : {}}
            >
              <span
                className="w-7 h-7 rounded-full flex items-center justify-center text-base"
                style={{ background: activeMember?.id === m.id ? "rgba(255,255,255,0.3)" : m.color + "33" }}
              >
                {m.avatar || ROLE_EMOJI[m.role] || "🙂"}
              </span>
              <span className="hidden sm:inline">{m.name}</span>
            </button>
          ))}
        </div>

        <button
          data-testid="logout-btn"
          onClick={logout}
          className="text-sm font-bold text-slate-400 hover:text-red-500 px-2"
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
